import React from 'react';
import { useSelector } from 'react-redux';
import { actions, ACTIONS_TYPES } from 'redux/local';
import { VALIDATION } from 'constant';
import Shared from 'screens/shared';
import { _t, isObjectEqual } from 'utils';
import { formField } from 'types';

export default ({
  isUpdate = false,
  id,
}) => {
  const { [ACTIONS_TYPES.DATA_CENTER.GET]: datacenter = {} } = useSelector((e) => e);
  const { properties: dcProps = {} } = datacenter;
  const { name = '', location = '' } = isUpdate ? dcProps : {};

  const model = { name, location };

  const fields = [
    formField.text({
      name: 'name',
      title: _t('Name'),
    }),
    // formField.textarea({
    //   name: 'description',
    //   title: _t('Description'),
    // }),
    formField.location({
      name: 'location',
      title: _t('Region'),
      disabled: isUpdate,
    }),
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      max: 255,
    },
    {
      name: 'location',
      type: VALIDATION.REQUIRED,
    },
  ];

  const submitHandler = (properties) => {
    if (isUpdate) {
      delete properties.location;
      if (!isObjectEqual(properties, dcProps)) {
        actions.dataCenter.update({ id, properties });
      }
    } else {
      properties.secAuthProtection = false;
      actions.dataCenter.create({ dataCenter: { properties } });
    }
  };

  return (
    <Shared.forms.Form
      fields={fields}
      fieldsValues={model}
      onSubmit={submitHandler}
      isCancel={false}
      validations={validations}
    />
  );
};
